import React from 'react';
import { Helmet } from 'react-helmet';
import PublicWrapper from 'shared/components/layout/PublicWrapper';
import LookBuilderSection from '../sections/LookBuilderSection/LookBuilderSection';
import { useTranslation } from 'react-i18next';

const LookBuilder = () => {
  const { t } = useTranslation();

  return (
    <PublicWrapper>
      <Helmet>
        <title>{t('lookbuilder_meta_title', 'From Inspiration to Purchase - AI-Powered Look Builder | Likiee')}</title>
        <meta
          name='description'
          content={t(
            'lookbuilder_meta_description',
            'Transform any fashion inspiration into a complete shoppable outfit. Upload a photo and our AI instantly finds every item across thousands of stores. Build your perfect look effortlessly with Likiee.',
          )}
        />
        <meta
          name='keywords'
          content='fashion look builder, AI outfit creator, visual fashion search, shop the look, fashion inspiration, outfit builder, style matching, fashion AI, clothing finder, look recreation'
        />

        {/* Open Graph / Facebook */}
        <meta property='og:type' content='website' />
        <meta
          property='og:title'
          content={t('lookbuilder_meta_title', 'From Inspiration to Purchase - AI-Powered Look Builder | Likiee')}
        />
        <meta
          property='og:description'
          content={t(
            'lookbuilder_meta_description',
            'Transform any fashion inspiration into a complete shoppable outfit. Upload a photo and our AI instantly finds every item across thousands of stores.',
          )}
        />
        <meta property='og:image' content='/images/lookbuilder-og.jpg' />

        {/* Twitter */}
        <meta name='twitter:card' content='summary_large_image' />
        <meta
          name='twitter:title'
          content={t('lookbuilder_meta_title', 'From Inspiration to Purchase - AI-Powered Look Builder | Likiee')}
        />
        <meta
          name='twitter:description'
          content={t(
            'lookbuilder_meta_description',
            'Transform any fashion inspiration into a complete shoppable outfit. Upload a photo and our AI instantly finds every item across thousands of stores.',
          )}
        />

        {/* Structured Data */}
        <script type='application/ld+json'>
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'From Inspiration to Purchase - Look Builder',
            description:
              'Transform any fashion inspiration into a complete shoppable outfit with AI-powered visual search and look building.',
            provider: {
              '@type': 'Organization',
              name: 'Likiee',
              url: 'https://likiee.com',
            },
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://likiee.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          })}
        </script>
      </Helmet>

      <LookBuilderSection />
    </PublicWrapper>
  );
};

export default LookBuilder;
